import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const BasicReservationForm = ({quest}) => {
  const { businessId } = useParams();
  const { businessToken, userToken, user} = useAuth();
  const [sending, setSending] = useState(false)
  const [formData, setFormData] = useState({
    business: businessId || "", // Zajištění, že businessId nebude undefined
    date: "",
    numberOfPeople: "",
    item: "",
    table:"",
  });
  const [name, setName] = useState("")
  const [message, setMessage] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  
  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      date: formatDate(date), // Formátování date na 'yyyy-MM-dd'
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (user) {
    try {
      setSending(true)
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/basic-reservation/create`,
        { ...formData, user: user._id, time: selectedSlot }, // Správná syntaxe: Spojení objektů
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      
      setMessage(response.data.message);
    } catch (err) {
      setMessage(err.response?.data?.message || "Něco se pokazilo");
    } finally {
      setSending(false)
      setTimeout(() => {
        setMessage(null)
      }, 1500)
    }
    }
    if (quest) {
      try {
        setSending(true)
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/basic-reservation//quest-create`,
          { ...formData, quest, time: selectedSlot }, 
        );
        
        setMessage(response.data.message);
      } catch (err) {
        setMessage(err.response?.data?.message || "Něco se pokazilo");
      } finally {
        setSending(false)
        setTimeout(() => {
          setMessage(null)
        }, 1500)
      }
    }
  };

  // Funkce pro formátování data na 'yyyy-MM-dd'
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Měsíce začínají od 0, proto přičítáme 1
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Vypsání slotů
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState("");

  useEffect(() => {
    const fetchAvailableSlots = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/basic-reservation/available-slots`,
          {
            params: { businessId },
          }
        );
        setAvailableSlots(response.data);

      } catch (err) {
        console.log(err.response?.data?.message || "Chyba při načítání dat");
      }
    };

    if (businessId) {
      fetchAvailableSlots();
    }
  }, [businessId]);
  
  // Porovnání formátovaných dat
  const filteredSlots = availableSlots.filter(slot => formatDate(new Date(slot.date)) === formData.date);

  const handleSlotChange = (e) => {
    setSelectedSlot(e.target.value);
  };

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      date: formatDate(new Date())
    }))
  }, [])

  const handleBusinessFormSubmit = async (e) => {
    e.preventDefault()

    try {
      setSending(true)
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/basic-reservation/business-create`, 
        {...formData, time: selectedSlot, name: name},
        {
          headers: {
            Authorization: `Bearer ${businessToken}`
          }
        }
      )
      setMessage(response.data.message)
    } catch (err) {
      setMessage(err.response?.data?.message || "Něco se pokazilo")
    } finally {
      setSending(false)
      setTimeout(() => {
        setMessage(null)
      }, 2000)
    }
  }

  return (
    <div>
      <div className="business-container">
      {user || quest ? (<div>
      <form onSubmit={handleSubmit}>
        <Calendar onChange={handleDateChange} />
        <div className="basic-container">
          <h2 className="check-title">Kdy:</h2>
          {filteredSlots.length === 0 ? (
            <p>Žádné dostupné sloty</p>
          ) : (
            <select value={selectedSlot} onChange={handleSlotChange} className="basic-input reservation-select">
              <option value="">Vyberte čas příchodu</option>
              {filteredSlots.map((slot, index) => (
                <optgroup key={index} label={`${slot.date} - ${slot.dayOfWeek}`}>
                  {slot.workHours.map((hour, i) => (
                    <option key={i} value={hour.startTime}>
                      {hour.startTime}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          )}
        </div>
      <div className="basic-container">
      <h2 className="check-title">Počet osob:</h2>
        <input
          className="basic-input hotel-input"
          type="number"
          name="numberOfPeople"
          placeholder="Počet osob"
          value={formData.numberOfPeople}
          onChange={handleChange}
          required
        />
      </div>
      <div className="basic-container">
      <h2 className="check-title">Poznámka:</h2>
        <input 
        className=" basic-input hotel-input"
          type="text"
          name="item"
          placeholder="Poznámka"
          value={formData.item}
          onChange={handleChange}
        />
        </div>
         <button type="submit" className="hotel-submit-button">{sending ? "Vytvářím..." : "Potvrdit"}</button>
        </form>
        </div>
        ) : (
<div>
  <form onSubmit={handleBusinessFormSubmit}>
  <Calendar onChange={handleDateChange} />
        <div className="basic-container">
        
          <h2 className="check-title">Kdy:</h2>
          {filteredSlots.length === 0 ? (
            <p>Žádné dostupné sloty</p>
          ) : (
            <select value={selectedSlot} onChange={handleSlotChange} className="basic-input reservation-select" required>
              <option value="">Vyberte čas příchodu</option>
              {filteredSlots.map((slot, index) => (
                <optgroup key={index} label={`${slot.date} - ${slot.dayOfWeek}`}>
                  {slot.workHours.map((hour, i) => (
                    <option key={i} value={hour.startTime}>
                      {hour.startTime}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          )}
        </div>
        <div className="basic-container">
      <h2 className="check-title">Jméno a přijmení:</h2>
        <input 
        className=" basic-input hotel-input"
          type="text"
          name="name"

          value={name || ""}
          onChange={(e) => setName(e.target.value)}
          required
        />
        </div>
      <div className="basic-container">
      <h2 className="check-title">Počet osob:</h2>
        <input
          className="basic-input hotel-input"
          type="number"
          name="numberOfPeople"

          value={formData.numberOfPeople}
          onChange={handleChange}
          required
        />
      </div>
      <div className="basic-container">
      <h2 className="check-title">Místo / Stůl:</h2>
        <input 
        className=" basic-input hotel-input"
          type="number"
          name="table"
          value={formData.table}
          onChange={handleChange}

        />
        </div>
      <div className="basic-container">
      <h2 className="check-title">Poznámka:</h2>
        <input 
        className=" basic-input hotel-input"
          type="text"
          name="item"

          value={formData.item}
          onChange={handleChange}
        />
        </div>
         <button type="submit" className="hotel-submit-button">{sending ? "Vytvářím..." : "Potvrdit"}</button>
        </form>
        </div>
        )}
      {message && <p className="message">{message}</p>}
    </div>
  </div>
  );
};

export default BasicReservationForm;